import { types } from 'mobx-state-tree';
import { PhoneNumberType } from '../types/PhoneNumber';

const StoragePhoneNumber = types.model('StoragePhoneNumber', {
  type: PhoneNumberType,
  number: types.string
});

export default StoragePhoneNumber;
